import React, {useState, useEffect, useRef} from 'react'
import './Sortbar.css'
import Sorticon from '../Assets/Sorticon.png';

function Sortbar() {
   
    const [open, setOpen] = useState(false);

    let menuRef = useRef();

    useEffect(() => {
        let handler = (e)=>{
            if(!menuRef.current.contains(e.target)){
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const handleSort = (sortType) => {
        // Dispatch custom event for Homepage to listen to
        window.dispatchEvent(new CustomEvent('sortChange', { detail: { sortType } }));
        setOpen(false);
    };

    return (
        <div className={`menu ${open? 'active' : ''}`} onClick={()=>{setOpen(!open)}} ref={menuRef}>
            <img src={Sorticon} className='sor1' alt='Sort icon'></img>
            <div className='sor2'>Sort by</div>
            <ul className={`dropdown-menu ${open? 'active' : 'inactive'}`}>
                <Dropdownitem text='MRI Wait Times' onClick={() => handleSort('mri-wait-time')}></Dropdownitem>
                <Dropdownitem text='MRI Distance' onClick={() => handleSort('mri-distance')}></Dropdownitem>
                <Dropdownitem text='CT Wait Times' onClick={() => handleSort('ct-wait-time')}></Dropdownitem>
                <Dropdownitem text='CT Distance' onClick={() => handleSort('ct-distance')}></Dropdownitem>
            </ul>
        </div>
    );
}

function Dropdownitem(props) {
    return(
        <li className='dropdown-item' onClick={props.onClick}>
            {props.text}
        </li>
    );
}

export default Sortbar;
